/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient, HttpProgressEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ORGANISATION_PLACEHOLDER,
  REGISTER_PLACEHOLDER,
} from '@assetaccountant/core/http-token.interceptor';
import { uploadProgress } from '@assetaccountant/core/utils/upload-progress';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { OperationResponse } from '../models/generic/operation-response';
import { CreateOrganisationInvitationCommand } from '../models/organisation-invitation/create-organisation-invitation.command';
import { ResendInvitationCommand } from '../models/organisation-invitation/resend-invitation.command';
import { RevokeInvitationCommand } from '../models/organisation-invitation/revoke-invitation.command';
import { UpdateOrganisationUserCommand } from '../models/organisation-invitation/update-organisation-user.command';
import { UpdateOrganisationUsersCommand } from '../models/organisation-invitation/update-organisation-users.command';
import { OrganisationListItem } from '../models/organisation-list-item';
import { OrganisationUserDto } from '../models/organisation-user.dto';
import { CreateDemoRegisterResponse } from '../models/organisations/create-demo-register.response';
import { CreateOrganisationCommand } from '../models/organisations/create-organisation.command';
import { CreateOrganisationResponse } from '../models/organisations/create-organisation.response';
import { CreateRegisterCommand } from '../models/organisations/create-register.command';
import { CreateRegisterResponse } from '../models/organisations/create-register.response';
import { CreateSubscriptionCommand } from '../models/organisations/create-subscription.command';
import { DeleteOrganisationRegisterCommand } from '../models/organisations/delete-organisation-register.command';
import { GetOrganisationResponse } from '../models/organisations/get-organisation.response';
import { ListFeatureFlagsResponse } from '../models/organisations/list-feature-flags.response';
import { ListOrganisationPermissionsResponse } from '../models/organisations/list-organisation-permissions.response';
import { ListOrganisationRegisterRolesResponse } from '../models/organisations/list-organisation-register-roles.response';
import { ListOrganisationRegisterUsersQuery } from '../models/organisations/list-organisation-register-users.query';
import { ListOrganisationRegisterUsersResponse } from '../models/organisations/list-organisation-register-users.response';
import { ListOrganisationRegistersResponse } from '../models/organisations/list-organisation-registers.response';
import { ListOrganisationRolesResponse } from '../models/organisations/list-organisation-roles.response';
import { ListOrganisationUsersQuery } from '../models/organisations/list-organisation-users.query';
import { ListOrganisationUsersResponse } from '../models/organisations/list-organisation-users.response';
import { RemoveOrganisationUserCommand } from '../models/organisations/remove-organisation-user.command';
import { SetBillingCountryCommand } from '../models/organisations/set-billing-country.command';
import { UpdateOrganisationRegisterUserCommand } from '../models/organisations/update-organisation-register-user.command';
import { UpdateOrganisationUserCommand as UpdateOrganisationUserCommand_1 } from '../models/organisations/update-organisation-user.command';
import { UpdateOrganisationCommand } from '../models/organisations/update-organisation.command';
import { UploadLogoCommand } from '../models/organisations/upload-logo.command';
import { GetSubscriptionPackageOptionsQuery } from '../models/subscriptions/get-subscription-package-options.query';
import { GetSubscriptionPackageOptionsResponse } from '../models/subscriptions/get-subscription-package-options.response';
import { GetSubscriptionPricingResponse } from '../models/subscriptions/get-subscription-pricing.response';
import { GetSubscription2Response } from '../models/subscriptions/get-subscription2.response';
import { UpdateSubscriptionCommand } from '../models/subscriptions/update-subscription.command';
import { CreateTagCommand } from '../models/tags/create-tag.command';
import { CreateTagResponse } from '../models/tags/create-tag.response';
import { GetTagQuery } from '../models/tags/get-tag.query';
import { GetTagResponse } from '../models/tags/get-tag.response';
import { ListTagsQuery } from '../models/tags/list-tags.query';
import { ListTagsResponse } from '../models/tags/list-tags.response';
import { UpdateTagCommand } from '../models/tags/update-tag.command';
import { UpdateTagResponse } from '../models/tags/update-tag.response';

@Injectable({
  providedIn: 'root',
})
export class OrganisationV2Api {
  constructor(private http: HttpClient) {}

  createDemoRegister(organisationId?: number | null): Observable<CreateDemoRegisterResponse> {
    return this.http.post<CreateDemoRegisterResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/demo-register`,
      {},
    );
  }

  createOrganisation(command: CreateOrganisationCommand): Observable<CreateOrganisationResponse> {
    return this.http.post<CreateOrganisationResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations`,
      command,
    );
  }

  createPaymentCustomer(organisationId?: number | null): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/payment-customer`,
      {},
    );
  }

  createRegister(command: CreateRegisterCommand): Observable<CreateRegisterResponse> {
    return this.http.post<CreateRegisterResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/register`,
      command,
    );
  }

  /**
   * @deprecated The logic for CreateSubscriptionCommand vrs UpdateSubscriptionCommand is now on the server so always use UpdateSubscriptionCommand
   */
  createSubscription(command: CreateSubscriptionCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/subscription`,
      command,
    );
  }

  createTags(command: CreateTagCommand): Observable<CreateTagResponse> {
    return this.http.post<CreateTagResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/tags`,
      command,
    );
  }

  deleteRegister(command: DeleteOrganisationRegisterCommand = {}): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}`,
    );
  }

  getLogo(organisationId?: number | null): Observable<Blob> {
    return this.http.get(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/logo`,
      { responseType: 'blob' },
    );
  }

  getOrganisation(organisationId?: number | null): Observable<GetOrganisationResponse> {
    return this.http.get<GetOrganisationResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}`,
    );
  }

  getSubscription(organisationId?: number | null): Observable<GetSubscription2Response> {
    return this.http.get<GetSubscription2Response>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/subscription`,
    );
  }

  getSubscriptionPackageOptions(
    query: GetSubscriptionPackageOptionsQuery = {},
  ): Observable<GetSubscriptionPackageOptionsResponse> {
    return this.http.get<GetSubscriptionPackageOptionsResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/subscription-options`,
      { params: { ...(query.shallowCheck ? { shallowCheck: query.shallowCheck } : {}) } },
    );
  }

  getSubscriptionPricing(
    organisationId?: number | null,
  ): Observable<GetSubscriptionPricingResponse> {
    return this.http.get<GetSubscriptionPricingResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/subscription-pricing`,
    );
  }

  getTags(query: GetTagQuery): Observable<GetTagResponse> {
    return this.http.get<GetTagResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/tag/${query.tagId}`,
    );
  }

  getUser(
    userId: string,
    options: { organisationId?: number } = {},
  ): Observable<OrganisationUserDto> {
    return this.http.get<OrganisationUserDto>(
      `${environment.servicesApiUrl}/api/v2/organisations/${options.organisationId ?? ORGANISATION_PLACEHOLDER}/users/${userId}`,
    );
  }

  invite(command: CreateOrganisationInvitationCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/invitation`,
      command,
    );
  }

  inviteOrUpdateUser(command: UpdateOrganisationUserCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/user`,
      command,
    );
  }

  inviteOrUpdateUsers(command: UpdateOrganisationUsersCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/users`,
      command,
    );
  }

  listFeatureFlags(organisationId?: number | null): Observable<ListFeatureFlagsResponse> {
    return this.http.get<ListFeatureFlagsResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/feature-flags`,
    );
  }

  listOrganisations2(): Observable<OperationResponse<OrganisationListItem[]>> {
    return this.http.get<OperationResponse<OrganisationListItem[]>>(
      `${environment.servicesApiUrl}/api/v2/organisations/list`,
    );
  }

  listPermissions(organisationId?: number | null): Observable<ListOrganisationPermissionsResponse> {
    return this.http.get<ListOrganisationPermissionsResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/permissions`,
    );
  }

  listRegisterRoles(
    organisationId?: number | null,
  ): Observable<ListOrganisationRegisterRolesResponse> {
    return this.http.get<ListOrganisationRegisterRolesResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/registerRoles`,
    );
  }

  listRegisters(organisationId?: number | null): Observable<ListOrganisationRegistersResponse> {
    return this.http.get<ListOrganisationRegistersResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/registers`,
    );
  }

  listRegisterUsers(
    command: ListOrganisationRegisterUsersQuery = {},
  ): Observable<ListOrganisationRegisterUsersResponse> {
    return this.http.get<ListOrganisationRegisterUsersResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/users`,
    );
  }

  listRoles(organisationId?: number | null): Observable<ListOrganisationRolesResponse> {
    return this.http.get<ListOrganisationRolesResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/roles`,
    );
  }

  listTags(query: ListTagsQuery = {}): Observable<ListTagsResponse> {
    return this.http.get<ListTagsResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/tags`,
      { params: { ...(query.includeDisabled ? { includeDisabled: query.includeDisabled } : {}) } },
    );
  }

  listUsers(query: ListOrganisationUsersQuery = {}): Observable<ListOrganisationUsersResponse> {
    return this.http.get<ListOrganisationUsersResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/users`,
      { params: { ...(query.includeInvited ? { includeInvited: query.includeInvited } : {}) } },
    );
  }

  removeSelf(organisationId?: number | null): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/users`,
    );
  }

  removeUser(command: RemoveOrganisationUserCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/users/${command.userIdToRemove}`,
    );
  }

  resendInvite(command: ResendInvitationCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/resendinvitation`,
      command,
    );
  }

  revokeInvite(command: RevokeInvitationCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/invitation/${command.invitationId}`,
    );
  }

  setBillingCountry(command: SetBillingCountryCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/set-billing-country`,
      command,
    );
  }

  updateLastAccessed(organisationId?: number | null): Observable<void> {
    return this.http.get<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${organisationId ?? ORGANISATION_PLACEHOLDER}/access`,
    );
  }

  updateOrganisation(command: UpdateOrganisationCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}`,
      command,
    );
  }

  updateRegisterUserAccess(command: UpdateOrganisationRegisterUserCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/users/${command.userId}/registers`,
      command,
    );
  }

  updateRegisterUser(command: UpdateOrganisationRegisterUserCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/users/${command.userId}`,
      command,
    );
  }

  updateSubscription(command: UpdateSubscriptionCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/subscription`,
      command,
    );
  }

  updateTag(command: UpdateTagCommand, tagId: string): Observable<UpdateTagResponse> {
    return this.http.put<UpdateTagResponse>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/tags/${tagId}`,
      command,
    );
  }

  updateUser(command: UpdateOrganisationUserCommand_1): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/users/${command.userId}`,
      command,
    );
  }

  uploadLogo(command: UploadLogoCommand): Observable<HttpProgressEvent | Blob> {
    const formData = new FormData();
    formData.append('file', command.file, command.file.name);

    return this.http
      .post(
        `${environment.servicesApiUrl}/api/v2/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/logo`,
        formData,
        { reportProgress: true, observe: 'events', responseType: 'blob' },
      )
      .pipe(uploadProgress());
  }
}
